import type { MutableRefObject } from "react";

/**
 * A tick as a big tile: press to tick or untick it, or press and drag across more tiles to set them all
 * the same way (from an empty tile they tick, from a ticked one they untick). `paint` comes from
 * useTickDrag().
 */
export function TickTile({
  on,
  label,
  title,
  set,
  paint,
}: {
  on: boolean;
  label: string;
  title?: string;
  set: (v: boolean) => void;
  paint: MutableRefObject<boolean | null>;
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={on}
      aria-label={label}
      title={title}
      className={`tick-tile${on ? " is-on" : ""}`}
      onPointerDown={(e) => {
        if (e.button !== 0) return;
        e.preventDefault(); // no text selection while dragging
        // A finger is held by the tile it started on: let go, so the tiles it moves over notice it.
        e.currentTarget.releasePointerCapture?.(e.pointerId);
        paint.current = !on;
        set(!on);
      }}
      onPointerEnter={() => {
        if (paint.current !== null && paint.current !== on) set(paint.current);
      }}
      onClick={(e) => {
        if (e.detail === 0) set(!on); // the keyboard (Space or Enter); a press has already set it
      }}
    />
  );
}
